import ChakraUIRenderer from "chakra-ui-markdown-renderer";
import React from "react";
import { Link } from "@chakra-ui/react";
export const ThemedMarkdownRenderer = () => {
    const preset = ChakraUIRenderer();
    preset["a"] = (props) => React.createElement(Link, { target: props.target, title: props.title, href: props.href, rel: props.rel, children: props.children, colorScheme: "reaBlue", color: "reaBlue.800", textDecoration: "underline" });
    return preset;
};
